import * as React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { useGetUserSettingTasksQuery } from "../services/usersSlice";
import { useAccount } from '@azure/msal-react';
import { createAppTheme } from './index';

type Props = {
  children: React.ReactNode;
};

export default function CustomStyles({ children }: Props) {
  const account = useAccount();
  const { data: getTaskSetting } = useGetUserSettingTasksQuery(undefined, {skip: !account});
  const mode: 'light' | 'dark' = getTaskSetting?.themeMode === 'dark' ? 'dark' : 'light';

  const theme = React.useMemo(() => {
    return createAppTheme(mode);
  }, [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
